import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { upsertPostUser } from '../../../tikexModule/services/upsertPostUser'
import getTempUserShortId from '../../../tikexModule/utils/getTempUserId'
import ImageUpload from '../../../tikexModule/components/ImageUpload'
import useLocalStorage from '../../../tikexModule/hooks/useLocalStorage'
import { baseURL } from '../../../utils/baseURL'
import { GetRecentPostUserImageIdsRes } from './types'
import GiveawayImageCard from '../../../tikexModule/components/GiveawayImageCard'
import Countdown from '../../../tikexModule/components/Countdown'
import CopyLinkButton from '../../../tikexModule/components/CopyLinkButton'
import Modal from '../../../tikexModule/components/Dashboard/Modal'

export default function Giveaway({
	env,
	postId,
	organizationShortId,
}: {
	env: string
	postId: string
	organizationShortId: string
}) {
	const [imgIdNew, setImgIdNew] = useLocalStorage<string | undefined>(
		'imgIdNew',
		undefined
	)
	const [data, setData] = useState<GetRecentPostUserImageIdsRes | undefined>(
		undefined
	)
	const [imgIdFavorite, setImgIdFavorite] = useLocalStorage<string | undefined>(
		'imgIdFavorite',
		undefined
	)
	const [imgIdClicked, setImgIdClicked] = useState<string | undefined>(
		undefined
	)
	const isMobile = window.innerWidth <= 768
	const [renderingStartedAt, setRenderingStartedAt] = useLocalStorage<
		string | undefined
	>('renderingStartedAt', undefined)
	const [isWelcomeModalShown, setIsWelcomeModalShown] =
		useLocalStorage<Boolean>('isWelcomeModalShown', false)
	const [isWelcomeModalVisible, setIsWelcomeModalVisible] =
		useState<Boolean>(false)
	const targetRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		axios
			.get(baseURL(env) + 'recentPostUserImageIds', {
				params: {
					postId,
					organizationShortId,
					tempUserShortId: getTempUserShortId(),
				},
			})
			.then((res: any) => {
				setData(res.data)
				if (!isWelcomeModalShown) {
					setTimeout(() => {
						setIsWelcomeModalVisible(true)
					}, 5000)
				}
			})
			.catch((err) => console.error(err))
	}, [])

	const [email, setEmail] = useState('')
	const handleSubmit = async (event: React.FormEvent, popup: Boolean) => {
		event.preventDefault()
		await upsertPostUser(
			{
				postId,
				tempUserShortId: getTempUserShortId(),
				email,
				popup,
				organizationShortId,
			},
			env
		)
		alert('E-mail saved')
		setIsWelcomeModalShown(true)
		setIsWelcomeModalVisible(false)
		targetRef.current?.scrollIntoView({ behavior: 'smooth' })
	}

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(event.target.value)
	}

	const handleShared = async (
		event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
	) => {
		event.preventDefault()
		const res = await axios.get(
			`https://t44-post-cover.s3.eu-central-1.amazonaws.com/${imgIdFavorite}.mp4`,
			{ withCredentials: false, responseType: 'blob' }
		)
		const shareData = {
			files: [
				new File([res.data], `${imgIdFavorite}.mp4`, {
					type: 'video/mp4',
				}),
			],
			title: 'Megosztom',
			text: 'Mentsd le a képekbe, és oszd meg storyban.',
		}
		navigator.share(shareData)
	}

	useEffect(() => {
		if (renderingStartedAt) {
			const date = new Date(renderingStartedAt)
			if (Date.now() > date.getTime() + 30000) {
				setImgIdFavorite(imgIdNew)
				setRenderingStartedAt(undefined)
			}
		}
	}, [])

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search)
		const adId = urlParams.get('adId')
		axios.put(baseURL(env) + 'tempUser', {
			giveawayId: postId,
			tempUserShortId: getTempUserShortId(),
			adId,
		})
	}, [])

	return (
		<>
			{data?.imgIds && data?.imgIds?.length >= 4 && (
				<>
					<div className="flex-responsive" id="giveaway" ref={targetRef}>
						<div>
							<h2>Játssz és nyerj</h2>
							<p>{data?.textIntro}</p>
							<hr className="space" />
							<ul className="text-list text-list-image">
								<li>
									<span
										style={{
											fontFamily: 'Icomoon',
											fontSize: '3rem',
											cursor: 'pointer',
										}}
									>
										&#xEC48;
									</span>
									<div className="content">
										<h3>1.a. Feltöltöm a kedvenc fotóm</h3>
										<p>
											Ha feltöltesz egy fotót, fél perc múlva megjelenik alatta
											a fotódat is felhasználva a promóciós videód
										</p>
										<ImageUpload
											bucket={'t44-post-cover'}
											completion={async (imgIdNew: string) => {
												setImgIdNew(imgIdNew)
												upsertPostUser(
													{
														postId: postId,
														tempUserShortId: getTempUserShortId(),
														imgIdUser: imgIdNew,
														organizationShortId,
													},
													env
												)
												setImgIdNew(imgIdNew)
												setRenderingStartedAt(new Date().toLocaleString())
												axios.get(
													`https://37seyyx4rg.execute-api.eu-central-1.amazonaws.com/default/create-promo-video`,
													{
														params: {
															imageId: imgIdNew,
															video1Id: data.videoStart,
															video2Id: data.videoEnd,
														},
													}
												)
												setImgIdFavorite(imgIdNew)
												setRenderingStartedAt(undefined)
											}}
											imgRef={'7'}
											title="Feltöltöm"
											classNameBtn="btn-text"
										/>
									</div>
								</li>
								<li>
									<span
										style={{
											fontFamily: 'Icomoon',
											fontSize: '3rem',
											cursor: 'pointer',
										}}
									>
										&#xEDC9;
									</span>
									<div className="content">
										<h3>2.a. Ha elkészült a promó videó,</h3>
										<p>
											tedd ki a sztoriba valamelyik közösségi oldalon,
											Facebookon, Instagramon, Tiktokon, s tégy egy erre az
											oldalra visszamutató linket rá{' '}
											<Countdown
												renderingStartedAt={renderingStartedAt}
												setRenderingStartedAt={setRenderingStartedAt}
											/>
										</p>
										{imgIdFavorite && isMobile && (
											<a
												className="btn-text"
												href={`https://t44-post-cover.s3.eu-central-1.amazonaws.com/${imgIdFavorite}.mp4`}
												onClick={handleShared}
											>
												Megosztom
											</a>
										)}
									</div>
								</li>
							</ul>
							{imgIdFavorite && (
								<video
									width="200"
									height="200"
									controls
									style={{ marginLeft: '118px', marginBottom: '30px' }}
								>
									<source
										src={`https://t44-post-cover.s3.eu-central-1.amazonaws.com/${imgIdFavorite}.mp4?${new Date().getTime()}`}
										type="video/mp4"
									/>
									Your browser does not support the video tag.
								</video>
							)}
						</div>
						<div>
							<div className="box-steps box-steps-vertical">
								<div className="step-item">
									<span>1</span>
									<div className="content">
										<h3>Válaszd ki vagy töltsd fel</h3>
										<div>
											<p>Mutasd magad, mondd el fotóval!</p>
										</div>
									</div>
								</div>
								<div className="step-item">
									<span>2</span>
									<div className="content">
										<h3>Oszd meg a nyereményjáték promócióját a sztoriban,</h3>
										<div>
											<p>
												hogy minél többen halljanak róla, s minél több
												szavazatot kapjon a fotód. Tudod, több szavazat, nagyobb
												esély a győzelemre. Az is nyerhet, aki csak szavaz.
												Részleteket{' '}
												<a href="http://tikex.com/nyeremenyjatek">itt</a>{' '}
												találsz a nyereményjáték sorsolásról, s az adatkezelési
												szabályzatot <a href="http://tikex.com/gdpr">itt</a>{' '}
												találod.
											</p>
										</div>
									</div>
								</div>
								<div className="step-item">
									<span>3</span>
									<div className="content">
										<h3>
											Helyezz el egy linket a megosztásodhoz jól látható helyre,
										</h3>
										<div>
											<p>
												hogy azok is idetaláljanak, akik még nem jártak az
												oldalon.
											</p>
										</div>
										<CopyLinkButton />
									</div>
								</div>
								<div className="step-item">
									<span>4</span>
									<div className="content">
										<h3>Add meg az email címed,</h3>
										<div>
											<p>hogy kapcsolatba léphessünk veled, ha nyernél!</p>
										</div>
										<form className="form-box">
											<div className="input-text-btn">
												<input
													className="input-text"
													value={email}
													onChange={handleChange}
												/>
												<input
													type="submit"
													value="Elküldöm"
													className="btn"
													onClick={(event: React.FormEvent) => {
														handleSubmit(event, false)
													}}
												/>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row align-items-center">
						<div
							className="col-lg-12 col-md-12"
							style={{
								position: 'relative',
							}}
						>
							<hr className="space visible-sm" />
							<div
								className="grid-list list-gallery grid-wall-1"
								data-lightbox-anima="fade-top"
								data-columns={2}
							>
								<div className="grid-box">
									<GiveawayImageCard
										imgId={data?.imgIds[0]}
										postId={postId}
										imgIdClicked={imgIdClicked}
										setImgIdClicked={setImgIdClicked}
										imgIdFavorite={imgIdFavorite}
										setImgIdFavorite={setImgIdFavorite}
										organizationShortId={organizationShortId}
										width={383}
										height={287}
									/>
									<GiveawayImageCard
										imgId={data?.imgIds[1]}
										postId={postId}
										imgIdClicked={imgIdClicked}
										setImgIdClicked={setImgIdClicked}
										imgIdFavorite={imgIdFavorite}
										setImgIdFavorite={setImgIdFavorite}
										organizationShortId={organizationShortId}
										width={383}
										height={287}
									/>
									<GiveawayImageCard
										imgId={imgIdNew ?? data?.imgIds[2]}
										postId={postId}
										imgIdClicked={imgIdClicked}
										setImgIdClicked={setImgIdClicked}
										imgIdFavorite={imgIdFavorite}
										setImgIdFavorite={setImgIdFavorite}
										organizationShortId={organizationShortId}
										width={300}
										height={225}
									/>
									<GiveawayImageCard
										imgId={data?.imgIds[3]}
										postId={postId}
										imgIdClicked={imgIdClicked}
										setImgIdClicked={setImgIdClicked}
										imgIdFavorite={imgIdFavorite}
										setImgIdFavorite={setImgIdFavorite}
										organizationShortId={organizationShortId}
										width={150}
										height={112}
									/>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
			{isWelcomeModalVisible && (
				<Modal
					completion={() => {
						setIsWelcomeModalShown(true)
						setIsWelcomeModalVisible(false)
					}}
				>
					<div
						style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}
					>
						<h2>{data?.modalTitle}</h2>
						<span>{data?.modalSubtitle}</span>
						<form className="form-box">
							<div className="input-text-btn">
								<input
									className="input-text"
									value={email}
									onChange={handleChange}
								/>
								<input
									type="submit"
									value="Submit"
									className="btn"
									onClick={(event: React.FormEvent) => {
										handleSubmit(event, true)
									}}
								/>
							</div>
						</form>
					</div>
				</Modal>
			)}
		</>
	)
}
